import {useDebugValue} from 'react';

import {useSettings} from './';

const defaultSettings = {};

function useSubmitSettings(props) {
    const {
        submitSettings: propsSettings
    } = props;

    const {
        initialSettings,
        settings,
        changeSettings
    } = useSettings(defaultSettings, propsSettings);

    const result = {
        initialSettings,
        settings,
        changeSettings
    };

    useDebugValue(result);

    return result;
}

export {useSubmitSettings};
